__turbopack_context__.v({
  "buttons": "share-module-scss-module__VMzcMG__buttons",
  "share": "share-module-scss-module__VMzcMG__share",
});
